import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IAdminEmailView } from 'app/models/admin/admin';
import { IComplaintSearchViewModel } from 'app/models/search/search';
import { IReportSelectItems, ISelectItems } from 'app/models/shared/shared';
import { AdminService } from 'app/services/admin/admin.service';
import { ReportsService } from 'app/services/reports/reports.service';

@Component({
  selector: 'app-reports-emailAdmin',
  templateUrl: './emailAdmin.component.html',
  styleUrls: ['./emailAdmin.component.scss']
})

export class EmailAdminComponent implements OnInit {
  @Input() countyId: string = '';
  list: IAdminEmailView[] = [];
  currentEmail: IAdminEmailView;
  filter: string = '';
  showList: boolean = true;
  countyList: ISelectItems[] = [];

  searchParameters: IComplaintSearchViewModel;

  displayedColumns: string[] = ['countyId', 'emailTypeDescription', 'emailTo', 'emailCc'];

  dataSource = new MatTableDataSource<IAdminEmailView>(this.list);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  form = new UntypedFormGroup({
    countyId: new UntypedFormControl(''),
    emailTypeDescription: new UntypedFormControl(''),
    emailTo: new UntypedFormControl(''),
    emailCc: new UntypedFormControl('')
  });

  constructor(public adminService: AdminService,
    public sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.getData();
    this.dataSource.data = this.list;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.countyList = this.sharedService.countyDropDownList;
    this.showList = true;
  }

  rowClick(row: IAdminEmailView) {
    this.currentEmail = row;
    this.form.controls['countyId'].setValue(row.countyId);
    this.form.controls['emailTypeDescription'].setValue(row.emailTypeDescription);
    this.form.controls['emailTo'].setValue(row.emailTo);
    this.form.controls['emailCc'].setValue(row.emailCc);

    this.form.controls['countyId'].disable();
    this.form.controls['emailTypeDescription'].disable();
    
    this.showList = false;
  }

  save(){
    let data = this.form.value;
    let value:IAdminEmailView = { 
      emailId: this.currentEmail.emailId,
      countyId: this.currentEmail.countyId,
      emailTypeId: this.currentEmail.emailTypeId,
      emailTypeDescription: this.currentEmail.emailTypeDescription,
      emailTo: data.emailTo,
      firstName: this.currentEmail.firstName,
      lastName: this.currentEmail.lastName,
      emailCc: data.emailCc,
      emailFrom: this.currentEmail.emailFrom,
      subject: this.currentEmail.subject
    };

    this.adminService.saveEmailAdminData(value).subscribe({
      next: response => {
        this.currentEmail.emailTo = data.emailTo;
        this.currentEmail.emailCc = data.emailCc;
        this.showList = true;
      },
      error: e => {
        this.sharedService.toastr.error("Save Failed. Please try again.");
      },
    });
  }

  getData() {
    this.adminService.getEmailData().subscribe({
      next: response => {
        this.list = response;
        this.dataSource.data = this.list;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.showList = true;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Business Data");
      },
    });
  }

  filterTable(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase();
    this.filter = this.dataSource.filter;
  }

  cancel(){
    this.showList = true;
  }
  
}
